import { castArray, filter, isEmpty, map, get } from 'lodash-es';
import * as React from 'react';
import { FormState } from 'react-hook-form';

interface ErrorsOwnProps {
  fieldNames: string | string[];
  useDangerouslySetInnerHTML?: boolean;
}

type ErrorsProps = ErrorsOwnProps & Partial<FormState<any>>;

const Errors: React.FC<ErrorsProps> = (props) => {
  const { errors, touchedFields, fieldNames, useDangerouslySetInnerHTML } =
    props;
  const invalidFields = filter(
    castArray(fieldNames),
    (fieldName) => get(errors, fieldName) && get(touchedFields, fieldName),
  );

  const errorMessages = map(
    invalidFields,
    (fieldName: string, i) =>
      get(errors, fieldName)?.message &&
      (useDangerouslySetInnerHTML ? (
        <li
          key={i}
          dangerouslySetInnerHTML={{
            __html: get(errors, fieldName)!.message!.toString(),
          }}
        />
      ) : (
        <li key={i}>{get(errors, fieldName)!.message!.toString()}</li>
      )),
  );

  return isEmpty(errorMessages) ? null : (
    <div className="alert alert-danger m-t m-b-0">
      <ul className="p-l-md">{errorMessages}</ul>
    </div>
  );
};

Errors.displayName = 'Errors';

export default Errors;
